import { toast } from "react-toastify"

const runUserAction = (request, { successMessage, fallbackError, onSuccess }) => request
  .then(res => {
    if (res.status >= 200 && res.status < 300) {
      toast.success(successMessage)
      if (onSuccess) onSuccess()
    }
    return null
  })
  .catch(err => {
    toast.error(err?.response?.data?.errors?.[0]?.detail || fallbackError)
  })

export default runUserAction
